import RaindropMotionFadeUp from "../raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

const RaindropMotionFadeUpGroup = ({ children, delay = 0.2 }) => {
  return (
    <>
      {children.map((child, index) => {
        return (
          <RaindropMotionFadeUp delay={delay * (index + 1)} key={index}>
            {child}
          </RaindropMotionFadeUp>
        );
      })}
    </>
  );
};

export default RaindropMotionFadeUpGroup;
